import type { NuxtApp } from '#app'

export function getNuxtContext(nuxtApp: NuxtApp) {
  const params = process.server ? nuxtApp._route.params : useRoute().params
  const query = process.server ? nuxtApp._route.query : useRoute().query

  return {
    ...nuxtApp,
    params,
    query,
  }
}
